class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector("details");
    this.summaryToggle = this.querySelector("summary");
    this.autofocus = this.getAttribute("autofocus");

    this.detailsContainer.addEventListener(
      "keyup",
      (event) => event.code.toUpperCase() === "ESCAPE" && this.close()
    );
    this.summaryToggle.addEventListener(
      "click",
      this.onSummaryClick.bind(this)
    );
    this.querySelector('button[type="button"]').addEventListener(
      "click",
      this.close.bind(this)
    );

    this.summaryToggle.setAttribute("role", "button");
  }

  isOpen() {
    return this.detailsContainer.hasAttribute("open");
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest("details").hasAttribute("open")
      ? this.close()
      : this.open(event);
  }

  onBodyClick(event) {
    if (
      !this.contains(event.target) ||
      event.target.classList.contains("modal-overlay")
    )
      this.close(false);
  }

  open(event) {
    this.onBodyClickEvent =
      this.onBodyClickEvent || this.onBodyClick.bind(this);
    event.target.closest("details").setAttribute("open", true);
    document.body.addEventListener("click", this.onBodyClickEvent);
    document.body.classList.add("overflow-hidden");

    document.querySelector(".section-header").classList.add("modal-open");

    if (this.autofocus === "true")

      trapFocus(
        this.detailsContainer.querySelector('[tabindex="-1"]'),
        this.detailsContainer.querySelector('input:not([type="hidden"])')
      );
  }

  close(focusToggle = true) {
    removeTrapFocus(focusToggle ? this.summaryToggle : null);
    this.detailsContainer.removeAttribute("open");
    document.body.removeEventListener("click", this.onBodyClickEvent);
    document.body.classList.remove("overflow-hidden");

    document.querySelector(".section-header").classList.remove("modal-open");
  }
}

customElements.define("details-modal", DetailsModal);


class SearchModal extends DetailsModal {
  constructor() {
    super();

    this.menuItems = this.querySelectorAll('.search-modal-menu__item');
    this.menu = this.querySelector('#search-modal-menu');
    this.subMenus = this.querySelectorAll('.search-modal-sub-menu');
    this.closeButton = this.querySelectorAll('.close');

    this.menuItems.forEach((target) => {
      target.addEventListener('click', () => {
        this.showSubMenu(target);
      });
    });

    this.closeButton.forEach((target) => {
      target.addEventListener('click', () => {
        this.hideSubMenu(target);
      });
    });
  }

  showSubMenu(target) {
    const index = Number(target.getAttribute('data-index')) - 1;
    this.subMenus[index].classList.remove('tw-hidden');
    this.menu.classList.add('tw-hidden');
  }

  hideSubMenu(target) {
    const index = Number(target.getAttribute('data-index')) - 1;
    this.subMenus[index].classList.add('tw-hidden');
    this.menu.classList.remove('tw-hidden');
  }
}

customElements.define('search-modal', SearchModal);
